import React, { useEffect } from 'react'
import './style.css'
import { Col, Container, Row } from 'react-bootstrap'
import Navigation from '../../../components/navigation/Navigation'
import Banner from '../../../components/banner/banner'
import MultiListCard from './multi-list-card/MultiListCard'
import Footer from '../../../components/footer/Footer';
import { APIINTEGRATION } from '../../../assets/images'
import SEO from '../../../components/seo/SEO'



const SecurityAndCompliance = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])



  return (
    <>
    <SEO
      title="Security & Compliance"
      description="Triumphal maintains rigorous security and compliance standards to protect enterprise data and ensure trustworthy delivery of every solution."
      path="/trust/security-and-compliance"
      keywords="security compliance, enterprise security, data protection"
    />
    <Navigation />
    <Banner title="Security & Compliance" bg={APIINTEGRATION} />

    <section className='api_intergration_section'>
        
        <Container className='mt-75 mb-75'>
            <div>
            <Row>
                <Col lg={11}>
                <div className='api_intergration_section_title'>

                    <h3>
                    Defense-in-depth security with audit-ready controls aligned to SOC 2 / ISO 27001 and enterprise procurement standards.

                    </h3>

                </div>
                
                
                </Col>

            </Row>

            </div>
            <div className='api_intergration_section_img'>
                {/* <Row>
                    <Col>
                    <div className='text-center'>
                    <img className='img-fluid' src={APISERVICE} alt="imae" />
                    </div>

                  
                    
                    
                    </Col>
                </Row> */}




            </div>

            <div className='api_intergration_cards'>
                <MultiListCard  />
            </div>
          
        </Container>

    </section>

    <Footer />
        
    </>
  )
}

export default SecurityAndCompliance